<template>
  <div class="features-1 row ml-0 mr-0 pb-0 pt-70">
    <div class="col-xl-4 px-0 SRbox">
      <div class="col-sm-12 autoCom mt-25" id="showsearch">
        <el-autocomplete
          class="col-sm-12"
          id="srchRstPageInput"
          v-model="keyword"
          :fetch-suggestions="querySearchAsync"
          placeholder="어디에 살고 싶으신가요? (지역/건물명 입력)"
          @select="handleSelect"
        >
          <i
            id="srchRstPage-SearchIcon"
            slot="suffix"
            class="jipvio-ui-icons-search jipvio-color1"
          ></i>
        </el-autocomplete>
      </div>

      <div class="M_filterbox text-left">
        <div class="M_filter">
          <i class="fas fa-bars pr-4 jipvio-color1"></i>
          <el-popover placement="bottom-start" width="70" trigger="click">
            <el-checkbox-group v-model="bldTypeList">
              <el-checkbox
                v-for="opt in selects.BPP"
                :key="opt.value"
                :label="opt.label"
              ></el-checkbox>
            </el-checkbox-group>
            <el-button class="pr-2 pl-2 jipvio-btn2" slot="reference"
              >매물유형 <i class="fas fa-angle-down"></i
            ></el-button>
          </el-popover>
          <el-popover
            class="pl-15"
            placement="bottom-start"
            width="100"
            trigger="click"
          >
            <el-checkbox-group v-model="ctrTypeList">
              <el-checkbox
                v-for="opt in selects.PTT"
                :key="opt.value"
                :label="opt.label"
              ></el-checkbox>
            </el-checkbox-group>
            <el-button class="pr-2 pl-2 jipvio-btn2" slot="reference"
              >거래유형 <i class="fas fa-angle-down"></i
            ></el-button>
          </el-popover>
          <el-popover
            class="pl-15"
            placement="bottom-start"
            width="200"
            trigger="click"
          >
            <span>보증금</span>
            <div align="right">
              <a>{{ showDepositMin }}~{{ showDepositMax }}</a>
            </div>
            <el-slider
              class="demonstration"
              @change="mouseUpEvt()"
              v-model="sliderValue"
              :step="sliderStep"
              range
              :max="1900"
              :show-tooltip="false"
              :marks="marks"
            ></el-slider>
            <el-button class="pr-2 pl-2 jipvio-btn2" slot="reference"
              >보증금 <i class="fas fa-angle-down"></i
            ></el-button>
          </el-popover>
          <el-popover
            class="pl-15"
            placement="bottom-start"
            width="100"
            trigger="click"
          >
            <el-checkbox-group v-model="TNORoomsList">
              <el-checkbox label="1개"></el-checkbox>
              <el-checkbox label="2개"></el-checkbox>
              <el-checkbox label="3개"></el-checkbox>
              <el-checkbox label="4개 이상"></el-checkbox>
            </el-checkbox-group>
            <el-button class="pr-2 pl-2 jipvio-btn2" slot="reference"
              >방 개수 <i class="fas fa-angle-down"></i
            ></el-button>
          </el-popover>
          <el-popover
            class="pl-15"
            placement="bottom-start"
            width="100"
            trigger="click"
          >
            <el-checkbox-group v-model="parkingYnList">
              <el-checkbox label="가능만 보기"></el-checkbox>
              <!-- <el-checkbox label="불가능"></el-checkbox> -->
            </el-checkbox-group>
            <el-button class="pr-2 pl-2 jipvio-btn2" slot="reference"
              >주차 <i class="fas fa-angle-down"></i
            ></el-button>
          </el-popover>
          <el-popover
            class="pl-15"
            placement="bottom-start"
            width="100"
            trigger="click"
          >
            <el-checkbox-group v-model="optionList">
              <el-checkbox
                v-for="option in selects.BIO"
                :label="option.label"
                :key="option.value"
              ></el-checkbox>
            </el-checkbox-group>
            <el-button class="pr-2 pl-2 jipvio-btn2" slot="reference"
              >옵션 <i class="fas fa-angle-down"></i
            ></el-button>
          </el-popover>
        </div>
      </div>

      <div class="row col-md-12 px-0 pb-40 ml-0 mr-0 SR_card">
        <div class="SR_result text-left">
          <h4>
            검색결과 <span>{{ pageInfo.totalCnt }}</span>
          </h4>
        </div>
        <div
          class="SRpptImgBox"
          v-for="(pl, index) in propertyList"
          :key="pl.propId"
        >
          <img
            class="SRpptImg"
            @click="toDetailPage(pl.propId)"
            v-lazy="pl.previewUrl"
          />
          <div class="like_btn" v-if="!pl.isFavorite">
            <i
              class="jipvio-ui-icons-love"
              @click="callLikeApi(index, pl.propId)"
            ></i>
          </div>
          <div class="like_btn" v-if="pl.isFavorite">
            <i
              class="jipvio-ui-icons-love_bk"
              @click="callLikeApi(index, pl.propId)"
            ></i>
          </div>
          <div class="SRoverlay ft-18">
            <p>
              {{
                pl.type != null ? sessionCoCodeMapDetail.BPP[pl.type].name : ""
              }}
            </p>
            <h5 class="SRpptImgH6">
              {{
                pl.paymentType != null
                  ? sessionCoCodeMapDetail.PTT[pl.paymentType].name
                  : ""
              }}
              {{ depositH(index) }}
            </h5>
            <p>
              <strong>면적</strong> {{ pl.useArea }}㎡ <strong>방/욕실</strong>
              {{ pl.roomCnt }} /
              {{ pl.wroomCnt }}
            </p>

            <div class="T_none">
              <i class="fl jipvio-ui-icons-gps_line"> </i>
              <p class="fl pl-10">
                {{ pl.addr }}<br />
                {{ pl.newAddr }}
              </p>
            </div>
            <!-- <h6 class="SRpptImgH6" style="width:100%;">id {{ pl.propId }}</h6> -->
            <!-- <el-button @click="toDetailPage(pl.propId)">자세히보기</el-button> -->
            <button
              class="jipvio-bg-color1"
              @click="toDetailPage(pl.propId)"
              style="cursor: pointer"
            >
              자세히 보기
            </button>
          </div>
        </div>
      </div>

      <el-pagination
        :page-size="pageInfo.sizePerPage"
        :page-count="pageInfo.totalPage"
        :current-page.sync="pageInfo.page"
        @current-change="changeCurrentPageNo"
        layout="prev, pager, next"
      >
      </el-pagination>
    </div>

    <div class="col-xl-8 px-0">
      <div id="SR_RV_Map_container" class="col-md-12 pl-0 pt-15">
        <div id="RVMapWrap">
          <div id="roadview" style="width: 100%; height: 100%"></div>
          <div id="rv_close" title="로드뷰닫기" @click="closeRoadview()">
            <span class="img"></span>
          </div>
        </div>
        <!-- "-->
        <div id="SRMapWrap" class="SRMapWrapClass">
          <div
            class="SRMapInner"
            id="SRmap"
            align="right"
            style="width: 100%; height: 100%"
          ></div>
          <div id="rvControl" @click="setRoadviewRoad()"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";

import {
  Button,
  CheckboxGroup,
  Checkbox,
  Select,
  Slider,
  Option,
  Input,
  Popover,
  Pagination,
  Autocomplete,
  MessageBox,
  Loading
} from "element-ui";

import { createNamespacedHelpers, mapGetters } from "vuex";
import propApi from "@/service/property";
import kko from "@/service/kakao";
import filestoreApi from "@/service/filestore";
import userInfo from "@/service/user";

// Vue.use(VueLazyload, {
//   error: "/img/logo.png",
//   loading: "/img/cov1.jpg",
//   attempt: 5,
//   listenEvents: ["scroll"]
// });

const { mapGetters: sessionMapGetters } = createNamespacedHelpers(
  "loginSession"
);

export default {
  name: "contact-us",
  bodyClass: "" /*sohyun이가 삭제*/,
  components: {
    [Button.name]: Button,
    [CheckboxGroup.name]: CheckboxGroup,
    [Checkbox.name]: Checkbox,
    [Select.name]: Select,
    [Slider.name]: Slider,
    [Option.name]: Option,
    [Input.name]: Input,
    [Popover.name]: Popover,
    [Pagination.name]: Pagination,
    [Autocomplete.name]: Autocomplete,
    [MessageBox.name]: MessageBox,
    [Loading.name]: Loading
  },
  data() {
    return {
      // kakao map
      overlayOn: null,
      marker: null,
      srRvMapContainer: null,
      // else
      pageInfo: {
        sizePerPage: 4,
        page: 1,
        totalPage: 10,
        totalCnt: 0
      },

      /* slider mark */
      marks: {
        1000: "1억"
      },

      searchResult: [], //검색바 검색 결과 리스트
      keyword: null, // 검색바 검색어

      bldTypeList: [], //선택된 매물유형 리스트
      ctrTypeList: [], //선택된 거래유형 리스트
      sliderValue: [0, 1900], //보증금 슬라이더 최소 최대 값
      sliderStep: 10, //보증금 슬라이더 움직이는 단위
      depositMin: null, // 보증금 최소값
      depositMax: null, // 보증금 최대값
      showDepositMin: 0, // 화면에 보여지는 보증금 최소값
      showDepositMax: 10 + "억", // 화면에 보여지는 보증금 최대값
      TNORoomsList: [], //선택된 방 개수 리스트
      parkingYnList: [], // 선택된 주차 가능여부
      optionList: [], // 선택된 빌트인 옵션 리스트

      selects: {
        BPP: [], // 건물종류
        BIO: [], //빌트인 옵션
        PTT: [] //거래유형
      },
      BppNameMap: {},
      PttNameMap: {},
      BioNameMap: {},
      BppMap: {},

      propertyList: [],

      propertyPositions: [],
      jipvioMarkers: [],
      customOverlay: [],
      RVMap: null,
      jipvioMap: null,
      jipvioGeocoder: null,
      jipvioRV: null,
      jipvioRV_Client: null,
      center: {
        x: null,
        y: null,
        name: null
      },
      swLat: null,
      swLng: null,
      neLat: null,
      neLng: null
    };
  },

  watch: {
    sliderValue(newValue, oldValue) {
      if (oldValue[0] != newValue[0]) {
        let slv = this.sliderValue[0];
        if (slv < 50) {
          this.sliderStep = 10;
          this.depositMin = slv * 100000;
          this.showDepositMin = slv * 10 + "만원";
        } else if (slv >= 50 && slv < 1000) {
          this.sliderStep = 50;
          this.depositMin = slv * 100000;
          this.showDepositMin = slv * 10 + "만원";
        } else if (slv >= 1000 && slv < 10000) {
          this.sliderStep = 10;
          if (Number(slv.toString().substr(2, 1)) == 0) {
            this.depositMin =
              (Number(slv.toString().substr(1, 1)) + 1) * 100000000;
            this.showDepositMin =
              Number(slv.toString().substr(1, 1)) + 1 + "억";
          } else {
            this.depositMin =
              (Number(slv.toString().substr(1, 1)) + 1) * 100000000 +
              Number(slv.toString().substr(2, 1)) * 10000000;
            this.showDepositMin =
              Number(slv.toString().substr(1, 1)) +
              1 +
              "억" +
              Number(slv.toString().substr(2, 1)) * 1000 +
              "만원";
          }
        } else if (slv == 1900) {
          this.depositMin = 1000000000;
          this.showDepositMin = "10억";
        }
      } else if (oldValue[1] != newValue[1]) {
        let slv = this.sliderValue[1];
        if (slv < 50) {
          this.sliderStep = 10;
          this.depositMax = slv * 100000;
          this.showDepositMax = slv * 10 + "만원";
        } else if (slv >= 50 && slv < 1000) {
          this.sliderStep = 50;
          this.depositMax = slv * 100000;
          this.showDepositMax = slv * 10 + "만원";
        } else if (slv >= 1000 && slv < 10000) {
          this.sliderStep = 10;
          if (Number(slv.toString().substr(2, 1)) == 0) {
            this.depositMax =
              (Number(slv.toString().substr(1, 1)) + 1) * 100000000;
            this.showDepositMax =
              Number(slv.toString().substr(1, 1)) + 1 + "억";
          } else {
            this.depositMax =
              (Number(slv.toString().substr(1, 1)) + 1) * 100000000 +
              Number(slv.toString().substr(2, 1)) * 10000000;
            this.showDepositMax =
              Number(slv.toString().substr(1, 1)) +
              1 +
              "억" +
              Number(slv.toString().substr(2, 1)) * 1000 +
              "만원";
          }
        } else if (slv == 1900) {
          this.depositMax = 1000000000;
          this.showDepositMax = "10억 이상";
        }
      }
    },
    bldTypeList(oldValue, newValue) {
      console.log("===============bldTypeList");
      console.log(newValue);
      this.changeCurrentPageNo(1);
    },
    ctrTypeList(oldValue, newValue) {
      console.log("===============ctrTypeList");
      console.log(newValue);
      this.changeCurrentPageNo(1);
    },
    TNORoomsList(oldValue, newValue) {
      console.log("===============TNORoomsList");
      console.log(newValue);
      console.log(this.TNORoomsList);
      this.changeCurrentPageNo(1);
    },
    parkingYnList(oldValue, newValue) {
      console.log("===============parkingYnList");
      console.log(newValue);
      this.changeCurrentPageNo(1);
    }
  },

  methods: {
    mouseUpEvt() {
      console.log(this.sliderValue);
      console.log(this.sliderStep);
      this.changeCurrentPageNo(1);
    },
    // optionList(){
    //   for(let i=0; i < this.pageInfo.totalCnt -1; i++){

    //   }
    // },

    /* 컴포넌트 재사용 될 때 */
    typeUpdate(type) {
      this.bldTypeList.push(type);
    },

    LikeToggle(idx) {
      if (this.propertyList[idx].isFavorite) {
        document
          .getElementById("MyElement" + idx)
          .classList.remove("jipvio-ui-icons-love_bk");
      } else {
        document
          .getElementById("MyElement" + idx)
          .classList.add("jipvio-ui-icons-love_bk");
      }
      this.propertyList[idx].isFavorite = !this.propertyList[idx].isFavorite;
    },

    toggleRoadview(position) {
      const self = this;
      this.jipvioRV_Client.getNearestPanoId(position, 50, function(panoId) {
        console.log(panoId);
        // 파노라마 ID가 null 이면 로드뷰를 숨깁니다
        if (panoId === null) {
          self.toggleMapWrapper(true, position);
        } else {
          self.toggleMapWrapper(false, position);

          // panoId로 로드뷰를 설정합니다
          self.jipvioRV.setPanoId(panoId, position);
        }
      });
    },

    // 지도를 감싸고 있는 div의 크기를 조정하는 함수입니다
    toggleMapWrapper(active, position) {
      if (active) {
        // 지도를 감싸고 있는 div의 너비가 100%가 되도록 class를 변경합니다
        document.getElementById("RVMapWrap").className = "";

        // 지도의 크기가 변경되었기 때문에 relayout 함수를 호출합니다
        this.jipvioMap.relayout();

        // 지도의 너비가 변경될 때 지도중심을 입력받은 위치(position)로 설정합니다
        this.jipvioMap.setCenter(position);
      } else {
        // 지도만 보여지고 있는 상태이면 지도의 너비가 50%가 되도록 class를 변경하여
        // 로드뷰가 함께 표시되게 합니다
        if (
          document
            .getElementById("RVMapWrap")
            .className.indexOf("view_roadview") === -1
        ) {
          document.getElementById("RVMapWrap").className = "view_roadview";

          // 지도의 크기가 변경되었기 때문에 relayout 함수를 호출합니다
          this.jipvioMap.relayout();

          // 지도의 너비가 변경될 때 지도중심을 입력받은 위치(position)로 설정합니다
          this.jipvioMap.setCenter(position);
        }
      }
    },

    // 지도 위의 로드뷰 도로 오버레이를 추가,제거하는 함수입니다

    // 지도 위의 로드뷰 버튼을 눌렀을 때 호출되는 함수입니다

    // 로드뷰에서 X버튼을 눌렀을 때 로드뷰를 지도 뒤로 숨기는 함수입니다
    closeRoadview() {
      let position = this.marker.getPosition();
      this.toggleMapWrapper(true, position);
    },

    toggleOverlay(active) {
      if (active) {
        this.overlayOn = true;

        // 지도 위에 로드뷰 도로 오버레이를 추가합니다
        this.jipvioMap.addOverlayMapTypeId(kakao.maps.MapTypeId.ROADVIEW);

        // 지도 위에 마커를 표시합니다
        this.marker.setMap(this.jipvioMap);

        // 마커의 위치를 지도 중심으로 설정합니다
        this.marker.setPosition(this.jipvioMap.getCenter());

        // 로드뷰의 위치를 지도 중심으로 설정합니다
        this.toggleRoadview(this.jipvioMap.getCenter());
      } else {
        this.overlayOn = false;

        // 지도 위의 로드뷰 도로 오버레이를 제거합니다
        this.jipvioMap.removeOverlayMapTypeId(kakao.maps.MapTypeId.ROADVIEW);

        // 지도 위의 마커를 제거합니다
        this.marker.setMap(null);

        let position = this.marker.getPosition();
        this.toggleMapWrapper(true, position);
      }
    },
    setRoadviewRoad() {
      let control = document.getElementById("rvControl");

      // 버튼이 눌린 상태가 아니면
      if (control.className.indexOf("active") === -1) {
        control.className = "active";

        // 로드뷰 도로 오버레이가 보이게 합니다
        this.toggleOverlay(true);
      } else {
        control.className = "";

        // 로드뷰 도로 오버레이를 제거합니다
        this.toggleOverlay(false);
      }
    },
    triggerSearch(show) {
      const showSearchEle = document.getElementById("showsearch");
      if (showSearchEle) {
        const search = showSearchEle.classList;
        if (show) {
          search.add("Zindex_1");
        } else {
          search.remove("Zindex_1");
        }
      }
    },

    async callLikeApi(idx, propId) {
      console.log(this.sessionUserInfo);
      if (this.sessionUserInfo == null) {
        MessageBox.confirm(
          "로그인이 필요합니다! 로그인 창으로 이동하시겠습니까?",
          "Warning",
          {
            confirmButtonText: "OK",
            cancelButtonText: "Cancel",
            type: "warning"
          }
        )
          .then(() => {
            this.$router.push({
              path: "/login"
              // query: { x: this.x, y: this.y }
            });
            console.log("login_page");
          })
          .catch(() => {
            console.log("fail");
            return;
          });
      } else {
        if (this.propertyList[idx].isFavorite) {
          console.log("removeAPi");
          const res = await propApi.removeUserLikeProperty(propId);
          if (res.status === 200) {
            this.LikeToggle(idx);
          } else {
            console.log("fail");
            return;
          }
        } else {
          console.log("likeAPi");
          const res = await propApi.saveUserLikeProperty(propId);
          if (res.status === 200) {
            this.LikeToggle(idx);
          } else {
            console.log("fail");
            return;
          }
        }
      }
    },

    printData() {
      console.log(this.depositMin);
      console.log(this.depositMax);
    },

    applyCommonCode() {
      //BPP========================================================
      this.sessionCoCodeMap.BPP.forEach((ele, dex) => {
        this.selects.BPP.push({
          value: ele.code,
          label: ele.name
        });
        this.BppNameMap[ele.name] = ele.code;
        this.BppMap[ele.code] = ele.name;
      });

      //BIO============ ============================================
      this.sessionCoCodeMap.BIO.forEach((ele, dex) => {
        this.selects.BIO.push({
          value: ele.id,
          label: ele.name
        });
        this.BioNameMap[ele.name] = ele.code;
      });

      //PTT========================================================
      this.sessionCoCodeMap.PTT.forEach((ele, dex) => {
        this.selects.PTT.push({
          value: ele.id,
          label: ele.name
        });
        this.PttNameMap[ele.name] = ele.code;
      });
    },

    async initMap() {
      const self = this;

      this.overlayOn = false; // 지도 위에 로드뷰 오버레이가 추가된 상태를 가지고 있을 변수
      this.srRvMapContainer = document.getElementById("SR_RV_Map_container");
      const srMapWrap = document.getElementById("SRMapWrap"); // 지도를 감싸고 있는 div 입니다
      const srMap = document.getElementById("SRmap");
      const rvContainer = document.getElementById("roadview"); //로드뷰를 표시할 div 입니다

      const options = {
        center: new kakao.maps.LatLng(this.$route.query.y, this.$route.query.x),
        level: 3
      };

      // 지도를 표시할 div와 지도 옵션으로 지도를 생성합니다
      this.jipvioMap = new kakao.maps.Map(srMap, options);
      this.jipvioRV = new kakao.maps.Roadview(rvContainer);
      this.jipvioRV_Client = new kakao.maps.RoadviewClient();

      //this.RVMap = new kakao.maps.Map(mapContainer, options);

      this.jipvioGeocoder = new kakao.maps.services.Geocoder();

      // 로드뷰에 좌표가 바뀌었을 때 발생하는 이벤트를 등록합니다
      kakao.maps.event.addListener(
        this.jipvioRV,
        "position_changed",
        function() {
          // 현재 로드뷰의 위치 좌표를 얻어옵니다
          let rvPosition = self.jipvioRV.getPosition();

          // 지도의 중심을 현재 로드뷰의 위치로 설정합니다
          self.jipvioMap.setCenter(rvPosition);

          // 지도 위에 로드뷰 도로 오버레이가 추가된 상태이면
          if (self.overlayOn) {
            // 마커의 위치를 현재 로드뷰의 위치로 설정합니다
            self.marker.setPosition(rvPosition);
          }
        }
      );

      // 마커 이미지를 생성합니다
      let markImage = new kakao.maps.MarkerImage(
        "https://t1.daumcdn.net/localimg/localimages/07/2018/pc/roadview_minimap_wk_2018.png",
        new kakao.maps.Size(26, 46),
        {
          // 스프라이트 이미지를 사용합니다.
          // 스프라이트 이미지 전체의 크기를 지정하고
          spriteSize: new kakao.maps.Size(1666, 168),
          // 사용하고 싶은 영역의 좌상단 좌표를 입력합니다.
          // background-position으로 지정하는 값이며 부호는 반대입니다.
          spriteOrigin: new kakao.maps.Point(705, 114),
          offset: new kakao.maps.Point(13, 46)
        }
      );

      // 드래그가 가능한 마커(로드 뷰)를 생성합니다
      this.marker = new kakao.maps.Marker({
        image: markImage,
        position: new kakao.maps.LatLng(
          this.$route.query.y,
          this.$route.query.x
        ),
        draggable: true
      });

      // 마커에 dragend 이벤트를 등록합니다
      kakao.maps.event.addListener(this.marker, "dragend", function(
        mouseEvent
      ) {
        // 현재 마커가 놓인 자리의 좌표입니다
        let position = self.marker.getPosition();

        // 마커가 놓인 위치를 기준으로 로드뷰를 설정합니다
        self.toggleRoadview(position);
      });

      //지도에 클릭 이벤트를 등록합니다
      kakao.maps.event.addListener(this.jipvioMap, "click", function(
        mouseEvent
      ) {
        // 지도 위에 로드뷰 도로 오버레이가 추가된 상태가 아니면 클릭이벤트를 무시합니다
        if (!self.overlayOn) {
          return;
        }

        // 클릭한 위치의 좌표입니다
        let position = mouseEvent.latLng;

        // 마커를 클릭한 위치로 옮깁니다
        self.marker.setPosition(position);

        // 클락한 위치를 기준으로 로드뷰를 설정합니다
        self.toggleRoadview(position);
      });

      // 전달받은 좌표(position)에 가까운 로드뷰의 파노라마 ID를 추출하여
      // 로드뷰를 설정하는 함수입니다

      //소현추가 줌인아웃, 로드뷰, 일반지도 추가하고싶음!!
      // 일반 지도와 스카이뷰로 지도 타입을 전환할 수 있는 지도타입 컨트롤을 생성합니다.
      const mapTypeControl = new kakao.maps.MapTypeControl();
      // 지도에 컨트롤을 추가해야 지도위에 표시됩니다
      // kakao.maps.ControlPosition은 컨트롤이 표시될 위치를 정의하는데 TOPRIGHT는 오른쪽 위를 의미합니다.
      this.jipvioMap.addControl(
        mapTypeControl,
        kakao.maps.ControlPosition.TOPRIGHT
      );

      // 지도 확대 축소를 제어할 수 있는  줌 컨트롤을 생성합니다.
      const zoomControl = new kakao.maps.ZoomControl();
      this.jipvioMap.addControl(zoomControl, kakao.maps.ControlPosition.RIGHT);
      //소현추가 끝

      // 지도의  레벨을 얻어옵니다
      const level = this.jipvioMap.getLevel();

      // 지도의 중심좌표를 얻어옵니다
      const latlng = this.jipvioMap.getCenter();

      // 지도의 현재 영역을 얻어옵니다
      const bounds = this.jipvioMap.getBounds();

      // 영역의 남서쪽 좌표를 얻어옵니다
      const swLatLng = bounds.getSouthWest();

      // 영역의 북동쪽 좌표를 얻어옵니다
      const neLatLng = bounds.getNorthEast();

      this.swLat = swLatLng.getLat();
      this.swLng = swLatLng.getLng();
      this.neLat = neLatLng.getLat();
      this.neLng = neLatLng.getLng();

      console.log("====click");
      await this.getAllProperty();

      this.makeMarkers();
      // kakao map event
      kakao.maps.event.addListener(
        this.jipvioMap,
        "dragend",
        this.changeMapData
      );
      kakao.maps.event.addListener(
        this.jipvioMap,
        "zoom_changed",
        this.changeMapData
      );
      // kakao.maps.event.addListener(
      //   this.jipvioMap,
      //   "center_changed",
      //   this.changeMapData
      // );
    },
    async changeMapData() {
      // 지도의 현재 영역을 얻어옵니다
      const bounds = this.jipvioMap.getBounds();

      // 영역의 남서쪽 좌표를 얻어옵니다
      const swLatLng = bounds.getSouthWest();

      // 영역의 북동쪽 좌표를 얻어옵니다
      const neLatLng = bounds.getNorthEast();
      console.log(swLatLng);
      console.log(neLatLng);

      this.swLat = swLatLng.getLat();
      this.swLng = swLatLng.getLng();
      this.neLat = neLatLng.getLat();
      this.neLng = neLatLng.getLng();

      /// ApiCall
      console.log("====changeMapData");
      await this.getAllProperty();

      this.makeMarkers();
    },

    async changeMap() {
      //센터 이동
      this.jipvioMap.setCenter(
        new kakao.maps.LatLng(this.center.y, this.center.x)
      );
      // 지도의 현재 영역을 얻어옵니다
      const bounds = this.jipvioMap.getBounds();

      // 영역의 남서쪽 좌표를 얻어옵니다
      const swLatLng = bounds.getSouthWest();
      const neLatLng = bounds.getNorthEast();

      this.swLat = swLatLng.getLat();
      this.swLng = swLatLng.getLng();
      this.neLat = neLatLng.getLat();
      this.neLng = neLatLng.getLng();

      // 영역의 북동쪽 좌표를 얻어옵니다

      console.log("===========changeMap");
      await this.getAllProperty();

      this.makeMarkers();
    },

    makeMarkers() {
      const self = this;
      // 초기화
      for (let i = 0; i < this.customOverlay.length; i++) {
        this.customOverlay[i].setMap(null);
      }
      this.customOverlay = [];
      this.propertyPositions = [];

      // 마커
      for (let i = 0; i < this.propertyList.length; i++) {
        this.propertyPositions.push({
          name: this.propertyList[i].dong,
          lat: this.propertyList[i].lat,
          lng: this.propertyList[i].lng
        });
      }

      // 커스텀 오버레이에 표출될 내용으로 HTML 문자열이나 document element가 가능합니다

      function setContent(i) {
        const content =
          '<div class="BGimage" id="markerImage' +
          i +
          '">' +
          '<div class="Map_marker">' +
          "<div>" +
          '<h6 class="jipvio-color1 text-left" style="margin: 9px 0 6px 0; padding-left: 30px">' +
          self.BppMap[self.propertyList[i].type] +
          "</h6>" +
          '<div class="likeShow">' +
          `<i
              class="jipvio-ui-icons-love"
              style="color:#5a2fca"
            ></i>` +
          "</div>" +
          '<div class="likeShow">' +
          '<i id="MyElement' +
          i +
          '"' +
          `style="color:#5a2fca"
              ></i>` +
          "</div>" +
          "</div>" +
          "<ul>" +
          "<li>전세 <span>" +
          self.depositM(i) +
          "</span></li>" +
          "<li>면적 <span>" +
          self.propertyList[i].useArea +
          "㎡</span></li>" +
          "<li>방 <span>" +
          self.propertyList[i].roomCnt +
          "</span></li>" +
          "</ul>" +
          "</div>" +
          "</div>" +
          "</div>";

        return content;
      }

      for (let i = 0; i < this.propertyPositions.length; i++) {
        let customOverlay = new kakao.maps.CustomOverlay({
          map: this.jipvioMap,
          position: new kakao.maps.LatLng(
            this.propertyPositions[i].lat,
            this.propertyPositions[i].lng
          ),
          content: setContent(i),
          yAnchor: 1
        });

        this.customOverlay.push(customOverlay);
        let mkId = "markerImage" + i;
        const el = document.getElementById(mkId);
        el.addEventListener("mouseover", function() {
          customOverlay.setZIndex(100);
        });
        el.addEventListener("mouseout", function() {
          customOverlay.setZIndex(0);
        });

        //마커 Custom class for favorite
        if (this.propertyList[i].isFavorite) {
          document
            .getElementById("MyElement" + i)
            .classList.add("jipvio-ui-icons-love_bk");
        }
      }
    },

    async getAllProperty() {
      if (
        this.swLat == null ||
        this.swLng == null ||
        this.neLat == null ||
        this.neLng == null
      )
        return;

      let bldTypeCodeList = [];
      let ctrTypCodeList = [];
      // let optionCodeList = [];
      let RoomCntList = [];
      let parkingYn = [];
      /* codeName 가져오기 */
      this.bldTypeList.forEach(ele =>
        bldTypeCodeList.push(this.BppNameMap[ele])
      );
      this.ctrTypeList.forEach(ele =>
        ctrTypCodeList.push(this.PttNameMap[ele])
      );
      // this.optionList.forEach(ele =>
      //   optionCodeList.push(this.PttNameMap[ele])
      // );

      /* API값이랑 똑같이 변환 */
      this.TNORoomsList.forEach(cnt =>
        RoomCntList.push(Number(cnt.replace(/[^0-9]/g, "")))
      );
      this.parkingYnList.forEach(Yn =>
        parkingYn.push(Yn == "가능만 보기" ? true : false)
      );
      const pagingReq = {
        pageNo: this.pageInfo.page - 1,
        sizePerPage: this.pageInfo.sizePerPage,
        swLat: this.swLat,
        swLng: this.swLng,
        neLat: this.neLat,
        neLng: this.neLng,
        typeList: bldTypeCodeList,
        paymentTypeList: ctrTypCodeList,
        depositFrom: this.depositMin,
        depositTo: this.depositMax,
        parkingYn: parkingYn[0],
        roomCntList: RoomCntList,
        orderByProperties: "deposit:desc"
      };
      console.log("====================getallProperty");
      console.log(pagingReq);

      const res = await propApi.getAllProperty(pagingReq);

      this.pageInfo.sizePerPage = res.pagingInfo.size;
      this.pageInfo.page = res.pagingInfo.pageNo + 1;
      this.pageInfo.totalPage = res.pagingInfo.totalPages;
      this.pageInfo.totalCnt = res.pagingInfo.totalCnt;

      // for (let i = 0; i < res.payload.length; i++) {
      //   const fileIdList = res.payload[i].upldFileIdList;
      //   if (fileIdList.length > 0) {
      //     const fileDownloadRes = await filestoreApi.downloadFile(
      //       fileIdList[0]
      //     );
      //     if (fileDownloadRes.status === 200) {
      //       res.payload[i].imgUrl = window.URL.createObjectURL(
      //         new Blob([fileDownloadRes.payload])
      //       );
      //     }
      //   }
      // }

      this.propertyList = res.payload;
    },

    changeCurrentPageNo: async function(pageNo) {
      console.log("change Current");
      this.pageInfo.page = pageNo;
      console.log(this.pageInfo);
      await this.getAllProperty(this.swLat, this.swLng, this.neLat, this.neLng);
      this.makeMarkers();
    },

    async querySearchAsync(queryString, cb) {
      let searchResult = [];
      if (queryString != null && queryString != "") {
        // address 검색
        const kkoRes = await kko.getListByAddr(queryString);
        if (kkoRes.data.documents.length > 0) {
          kkoRes.data.documents.forEach(srl => {
            searchResult.push({
              value: srl.address_name,
              x: srl.x,
              y: srl.y
            });
          });
        } else {
          // keyword 검색
          const kkoResByKwd = await kko.getListByKeyWord(queryString, "");
          kkoResByKwd.data.documents.forEach(srl => {
            searchResult.push({
              value: srl.place_name,
              x: srl.x,
              y: srl.y
            });
          });
        }
        console.log("=========================kkoRes.data.documents");
        console.log(kkoRes.data.documents);
      }
      //timeout
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        cb(searchResult);
      }, 300);
    },

    handleSelect(item) {
      console.log(item);

      //==================실제 사용 코드
      // this.$router.push({
      //   path: "/search/result",
      //   query: { x: item.x, y: item.y, name: item.value }
      // });

      // this.keyword = item.value;
      // this.center.x = item.x;
      // this.center.y = item.y;
      // this.center.name = item.value;

      this.$router.push({
        path: "/search/result",
        query: {
          x: 126.858330553006,
          y: 37.5017185630595,
          name: "서울 구로구 고척동 134-112"
        }
      });

      this.keyword = "서울 구로구 고척동 134-112";
      this.center.x = 126.858330553006;
      this.center.y = 37.5017185630595;
      this.center.name = "서울 구로구 고척동 134-112";

      this.changeMap();
    },

    toDetailPage(value) {
      this.$router.push({
        path: "/prop/detail",
        query: { id: value }
      });
    },

    searchDeposit(deposit) {
      const depositVal = deposit < 0 ? false : deposit;

      const unitWords = ["원", "만"];
      const splitUnit = 10000;
      const splitCount = unitWords.length;
      let resultArray = [];
      let resultString = "";

      if (depositVal < 100000000) {
        for (let i = 0; i < splitCount; i++) {
          var unitResult =
            (depositVal % Math.pow(splitUnit, i + 1)) / Math.pow(splitUnit, i);
          unitResult = Math.floor(unitResult);
          if (unitResult > 0) {
            resultArray[i] = unitResult;
          }
        }
        for (var i = 0; i < resultArray.length; i++) {
          if (!resultArray[i]) continue;
          resultString = String(resultArray[i]) + unitWords[i] + resultString;
        }

        return resultString.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return depositVal / 100000000 + "억";
      }
    },

    depositM(i) {
      const depositVal =
        this.propertyList[i].deposit < 0 ? false : this.propertyList[i].deposit;

      const unitWords = ["원", "만"];
      const splitUnit = 10000;
      const splitCount = unitWords.length;
      let resultArray = [];
      let resultString = "";

      if (depositVal < 100000000) {
        for (let i = 0; i < splitCount; i++) {
          var unitResult =
            (depositVal % Math.pow(splitUnit, i + 1)) / Math.pow(splitUnit, i);
          unitResult = Math.floor(unitResult);
          if (unitResult > 0) {
            resultArray[i] = unitResult;
          }
        }
        for (var i = 0; i < resultArray.length; i++) {
          if (!resultArray[i]) continue;
          resultString = String(resultArray[i]) + unitWords[i] + resultString;
        }

        return resultString.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return depositVal / 100000000 + "억";
      }
    },
    depositH(i) {
      const depositVal =
        this.propertyList[i].deposit < 0 ? false : this.propertyList[i].deposit;
      const unitWords = ["원", "만원", "억", "조", "경"];
      const splitUnit = 10000;
      const splitCount = unitWords.length;
      let resultArray = [];
      let resultString = "";

      for (var i = 0; i < splitCount; i++) {
        var unitResult =
          (depositVal % Math.pow(splitUnit, i + 1)) / Math.pow(splitUnit, i);
        unitResult = Math.floor(unitResult);
        if (unitResult > 0) {
          resultArray[i] = unitResult;
        }
      }
      for (var i = 0; i < resultArray.length; i++) {
        if (!resultArray[i]) continue;
        resultString = String(resultArray[i]) + unitWords[i] + resultString;
      }

      return resultString.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    // downloadFile: async function() {
    //   const res = await filestoreApi.downloadFile(6);
    //   console.log(res);

    //   this.testImg = window.URL.createObjectURL(new Blob([res.payload]));
    // }
  },
  created: async function() {
    this.applyCommonCode();
    this.keyword = this.$route.query.name;
    this.center.x = this.$route.query.x;
    this.center.y = this.$route.query.y;
    if (this.$route.query.type != undefined) {
      this.typeUpdate(this.$route.query.type);
    }
    // this.center.name = this.$route.query.name;
  },

  mounted() {
    const self = this;

    this.$root.$on("showSrchBar", function() {
      self.triggerSearch(false);
    });
    this.$root.$on("rmvSrchBar", function() {
      self.triggerSearch(true);
    });

    if (window.kakao && window.kakao.maps) {
      this.initMap();
    } else {
      const script = document.createElement("script");
      /* global kakao */
      const serviceKey = process.env.VUE_APP_KKO_SDK_KEY;

      script.onload = () => kakao.maps.load(this.initMap);

      script.src = `https://dapi.kakao.com/v2/maps/sdk.js?autoload=false&appkey=${serviceKey}&libraries=services`;
      // <head></head>에 위치
      document.head.appendChild(script);
    }
  },
  beforeRouteUpdate(to, form, next) {
    this.typeUpdate(to.query.type);
    next();
  },
  computed: {
    ...sessionMapGetters({
      sessionCoCodeMap: "getCoCodeMap",
      sessionCoCodeMapDetail: "getCoCodeMapDetail",
      sessionUserInfo: "getUserInfo"
    })
  }
};
</script>
<style>
/* roadview css 여기부터 */
.view_roadview {
  z-index: 10 !important;
}

#srRvMapContainer {
  overflow: hidden;
  height: 300px;
  position: relative;
}
#srMapWrap {
  width: 100%;
  height: 300px;
  z-index: 1;
}
#RVMapWrap {
  width: calc(50% - 5vh);
  height: calc(50% - 4vw);
  bottom: 8vh;
  left: 0;
  position: absolute;
  z-index: 0;
}

#srRvMapContainer.view_roadview #srMapWrap {
  width: 50%;
}

#rvControl {
  position: absolute;
  top: 5px;
  left: 5px;
  width: 42px;
  height: 42px;
  z-index: 1;
  cursor: pointer;
  background: url(https://t1.daumcdn.net/localimg/localimages/07/2018/pc/common/img_search.png)
    0 -450px no-repeat;
}

#rvControl.active {
  background-position: 0 -350px;
}
#rv_close {
  position: absolute;
  padding: 4px;
  top: 5px;
  left: 5px;
  cursor: pointer;
  background: #fff;
  border-radius: 4px;
  border: 1px solid #c8c8c8;
  box-shadow: 0px 1px #888;
}
#rv_close .img {
  display: block;
  background: url(https://t1.daumcdn.net/localimg/localimages/07/mapapidoc/rv_close.png)
    no-repeat;
  width: 14px;
  height: 14px;
}
/* roadview css 여기까지 */

/* 마커 css */
.BGimage {
  background: url(/img/jip_icons/jipvio-marker-pin.png) no-repeat;
  background-size: cover;
  width: 137px;
  height: 127px;
  position: absolute;
  top: -72px;
  left: -27px;
}
/* 마커 css 끝 */

#SRmap div div div:hover {
  z-index: 99;
}

.Map_marker {
  margin: 0 auto;
  bottom: -8px;
  left: 3px;
  line-height: 1;
  z-index: 1;
}

.Map_marker .likeShow {
  position: absolute;
  right: 17px;
  top: 9px;
}

.Map_marker ul {
  color: rgba(0, 0, 0, 0.4);
  font-size: 13px;
  padding-left: 30px;
  margin: 0;
  text-align: left;
}
.Map_marker ul li {
  list-style: none;
  margin-bottom: 3px;
}

.Map_marker ul li span {
  position: absolute;
  left: 70px;
  font-weight: 700;
  color: #000;
}

.SRMapWrapClass {
  width: 100%;
  height: 50vw;
  box-sizing: border-box;
}
.SRMapInner {
  position: absolute;
  top: 0;
  right: 0;
}

.SRbox .M_filterbox {
  overflow-x: scroll;
  margin-top: 5px;
  padding-left: 30px;
  padding-bottom: 20px;
  padding-top: 15px;
}
.SRbox .M_filterbox::-webkit-scrollbar {
  background-color: #ffffff;
  width: 10px; /*height는 가로축 스크롤바 길이, width는 세로축*/
}
.SRbox .M_filterbox::-webkit-scrollbar-track-piece {
  width: 80%;
}
.SRbox .M_filterbox::-webkit-scrollbar-thumb {
  /* display: none;  Chrome, Safari, Opera*/
  background-color: #5a2fca;
  width: 10px; /*height는 가로축 스크롤바 길이, width는 세로축*/
  border-radius: 10px;
  padding: 3px 0;
  background-clip: padding-box;
  border: 3px solid transparent;
}
.SRbox .M_filterbox::-webkit-scrollbar-track {
  /* display: none;  Chrome, Safari, Opera*/
  background-color: #e0e0e0;
  border-radius: 15px;
  box-shadow: inset 0 0 5px #ffffff;
}

.SRbox .M_filterbox .M_filter {
  width: 100%;
}
button.jipvio-btn2 {
  border-radius: 14px;
}

div.SR_Pop {
  /* width: 90%; */
}

.SR_card {
  /* border-top: 2px solid rgba(0, 0, 0, 0.1);
  border-bottom: 2px solid rgba(0, 0, 0, 0.1); */
  /* margin-top: 30px; */
}

.SR_card .SRpptImgBox .SRpptImg {
  position: absolute;
  object-fit: cover;
  height: 100%;
  cursor: pointer;
}

.SRpptImgBox:hover .SRoverlay {
  opacity: 1;
}
.SR_card .SR_result {
  width: 100%;
  padding-left: 1.03vw;
  padding-bottom: 2%;
}
.SR_card .SR_result h4 {
  color: rgba(0, 0, 0, 0.6);
  font-weight: 700;
  line-height: 21px;
}

.SR_card .SR_result h4 span {
  color: #000;
}

/* .SRpptImg {
  width: 90%;
  margin: auto;
} */

.SR_card .like_btn {
  position: absolute;
  top: 4%;
  right: 5%;
  z-index: 100;
  font-size: 25px;
  color: #fff;
  cursor: pointer;
}
.SR_card .SRpptImgBox .SRoverlay {
  width: 100%;
  height: 100%;
  background: #000000c0; /* Black see-through */
  position: absolute;
  padding: 16% 0 0 8%;
  transition: 0.5s ease;
  opacity: 0;
  color: #fff;
  text-align: center;
  z-index: 99;
}

.SR_card .SRpptImgBox .SRoverlay:hover {
  opacity: 1;
}

.SR_card .SRpptImgBox .SRoverlay .SRpptImgH6,
.SR_card .SRpptImgBox .SRoverlay p {
  color: #fff;
  width: 80%;
  line-height: 1.3em;
  text-align: left;
}
.SR_card .SRpptImgBox .SRoverlay .SRpptImgH6 {
  font-size: 1vw;
}

.SR_card .SRpptImgBox .SRoverlay p:nth-of-type(1) {
  font-size: 0.7vw;
}

.SR_card .SRpptImgBox .SRoverlay p:nth-of-type(2) {
  font-size: 0.85vw;
}

.SR_card .SRpptImgBox .SRoverlay button {
  width: 100%;
  height: 2.66vw;
  font-size: 1em;
  font-weight: bold;
  position: absolute;
  bottom: 0;
  left: 0;
  border: none;
  color: #fff;
}

#srchRstPageInput {
  border-radius: 18px;
  text-align: center;
}
#srchRstPageInput::placeholder {
  text-align: center;
}

#srchRstPage-SearchIcon {
  font-size: 25px;
  margin-top: 6px;
  margin-right: 4px;
}

.SRbox .el-pagination {
  position: absolute;
  bottom: 3%;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1;
}

@media screen and (max-width: 1700px) {
  .SRbox .M_filterbox .M_filter {
    width: 150%;
  }
}
@media screen and (max-width: 1550px) {
  .SR_card .SRpptImgBox .SRoverlay > p {
    margin-bottom: 0.7rem;
  }
}
@media screen and (min-width: 1199px) {
  .SR_card .SRpptImgBox {
    position: relative;
    width: 14.6vw;
    height: 14.6vw;
    margin: calc((50% - 14.6vw) / 2);
  }
}
@media screen and (max-width: 1199px) {
  .T_none {
    display: none;
  }

  .SRMapWrapClass {
    height: 421px;
    margin-bottom: 80px;
  }
  .SRbox .el-pagination {
    margin: 20px 0;

    bottom: -510px;
  }
  .SRbox .M_filterbox {
    padding-bottom: 15px;
    padding-top: 10px;
  }
  .SRbox .M_filterbox .M_filter {
    width: 100%;
  }
  .SR_card .SR_result {
    width: 100%;
    padding-left: 2.2%;
    margin-bottom: 2%;
  }

  .SR_card .SRpptImgBox {
    width: 46.355vw;
    height: 41.186vw;
    margin-right: 1.8vw;
    margin-left: 1.8vw;
  }
  .SR_card .SRpptImgBox .SRpptImg {
    position: relative;
    object-fit: cover;
    height: 65%;
  }
  .SR_card .SRpptImgBox .SRoverlay {
    opacity: 1;
    padding: 3% 0 0 8%;
    height: auto;
    color: black;
    background-color: #fff;
    transition: 0s;
    border: 2px solid rgba(0, 0, 0, 0.1);
    border-top: 0;
  }

  .SR_card .SRpptImgBox .SRoverlay button {
    display: none;
  }

  .SR_card .SRpptImgBox .SRoverlay .SRpptImgH6,
  .SR_card .SRpptImgBox .SRoverlay p {
    color: #000;
    width: 100%;
  }
  .SR_card .SRpptImgBox .SRoverlay .SRpptImgH6 {
    font-size: 1.6em;
    line-height: 1em;
    font-weight: 700;
    margin-bottom: 22px;
  }
  .SR_card .SRpptImgBox .SRoverlay p {
    color: rgba(0, 0, 0, 0.6);
  }
  .SR_card .SRpptImgBox .SRoverlay p:nth-of-type(1) {
    font-size: 0.9em;
    margin-bottom: 10px;
  }
  .SR_card .SRpptImgBox .SRoverlay p:nth-of-type(2) {
    font-size: 1.22em;
  }
  .SR_card .SRpptImgBox .SRoverlay p strong {
    font-weight: 700;
  }
  /*road view*/
  #RVMapWrap {
    /* width: calc(50% - 3vw);
    height: calc(50% + 5vw); */
    width: 100%;
    height: 100%;
    bottom: 0;
    left: 0;
    position: absolute;
    z-index: 0;
  }
}
@media screen and (max-width: 991px) {
  .SRbox .autoCom.Zindex_1 {
    transition: all 0.1s linear;
    opacity: 0;
    /* animation-delay: 2s; */
  }
  .SRbox .autoCom {
    margin-top: 0;
    position: fixed;
    top: 10px;
    left: 50%;
    transform: translateX(-50%);
    width: 60%;
    z-index: 1030;
    transition: all 0.5s linear;
  }
  .SRbox .M_filterbox {
    margin-top: 0px;
    padding-left: 30px;
    padding-bottom: 15px;
    padding-top: 5px;
  }

  /* .SRbox .M_filterbox .M_filter {
    width: 120%;
  } */
  .SR_card {
    margin-top: 10px;
    border: 0;
  }
  .SR_card .SR_result {
    width: 100%;
    border-top: 10px solid rgba(0, 0, 0, 0.1);
    border-bottom: 2px solid rgba(0, 0, 0, 0.1);
    box-sizing: border-box;
  }
  .SR_card .SR_result h4 {
    color: rgba(0, 0, 0, 0.6);
    font-weight: 700;
    line-height: 14px;
  }

  .SR_card .SR_result h4 span {
    color: #000;
  }
}

@media screen and (max-width: 768px) {
  .SR_card .SRpptImgBox {
    margin: 28px 0 28px 19px;
  }
}
@media screen and (max-width: 575px) {
  .SRbox .autoCom {
    top: 8px;
  }
  .SR_card .SRpptImgBox {
    width: 47.168vw;
  }
  .SRbox .M_filterbox .M_filter {
    width: 150%;
  }
}
@media screen and (max-width: 540px) {
  .SRbox .autoCom {
    width: 85%;
  }
  #srchRstPageInput {
    padding-left: 3vw !important;
    text-align: left;
  }
  .SRMapWrapClass {
    height: 321px;
    margin-bottom: 80px;
  }
  .SRbox .el-pagination {
    bottom: -412px;
  }

  .SR_card .SRpptImgBox {
    height: 55.559vw;
    margin: 28px 0 28px 10px;
  }

  .SR_card .SRpptImgBox .SRoverlay {
    padding: 7% 0 0 10%;
  }
  .SR_card .SRpptImgBox .SRoverlay .SRpptImgH6 {
    font-size: 1.25em;
    line-height: 1em;
    font-weight: 700;
    margin-bottom: 17px;
  }
  .SR_card .SRpptImgBox .SRoverlay p:nth-of-type(1) {
    font-size: 0.8em;
    margin-bottom: 13px;
  }
  .SR_card .SRpptImgBox .SRoverlay p:nth-of-type(2) {
    font-size: 0.9em;
  }
  .SR_card .SRpptImgBox .SRoverlay p strong {
    font-weight: 700;
  }
}
@media screen and (max-width: 480px) {
  .SR_card .SRpptImgBox .SRoverlay .SRpptImgH6 {
    font-size: 1.1em;
  }
  .SR_card .SRpptImgBox .SRoverlay p:nth-of-type(1) {
    font-size: 0.75em;
  }
  .SR_card .SRpptImgBox .SRoverlay p:nth-of-type(2) {
    font-size: 0.75em;
  }
  .SRbox .M_filterbox .M_filter {
    width: 180%;
  }
}
@media screen and (max-width: 414px) {
  .SR_card .SRpptImgBox .SRoverlay {
    padding: 7% 0 0 7%;
  }
  .SR_card .SRpptImgBox {
    margin: 28px 0 28px 7px;
  }
}
@media screen and (max-width: 376px) {
  .SR_card .SRpptImgBox .SRoverlay .SRpptImgH6 {
    font-size: 0.9em;
  }
  .SR_card .SRpptImgBox .SRoverlay p:nth-of-type(1) {
    font-size: 0.8em;
  }
  .SR_card .SRpptImgBox .SRoverlay p:nth-of-type(2) {
    font-size: 0.66em;
  }
}
@media screen and (max-width: 320px) {
  .SR_card .SRpptImgBox {
    margin: 28px 0 28px 6px;
  }
  .SR_card .SRpptImgBox .SRoverlay .SRpptImgH6 {
    font-size: 0.8em;
  }
  .SR_card .SRpptImgBox .SRoverlay p:nth-of-type(2) {
    font-size: 0.6em;
  }
}
</style>
